import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatrimonyListComponent } from './patrimony-list/patrimony-list.component';
import { PatrimonyFormComponent } from './patrimony-form/patrimony-form.component';
import { MaterialModule } from '../material/material.module';
import { PatrimonyViewComponent } from './patrimony-view/patrimony-view.component';
import { SharedModule } from '../shared/shared.module';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ComponentsModule } from '../components/components.module';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
@NgModule({
  declarations: [PatrimonyListComponent, PatrimonyFormComponent, PatrimonyViewComponent],
  imports: [CommonModule, MaterialModule, ComponentsModule, SharedModule, NgxMaskModule.forRoot()],
})
export class PatrimonyModule {}
